import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const bannerInit = {
    bannerState:{
        mainText: "",
        subText: "",
        tallBanner: false,
        success: null,
        link: null,
    } 
};

function bannerReducer(draft, { type, payload }) {
  switch (type) {
    case "changeBannerState": {
      draft.bannerState = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [BannerContext, BannerDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function BannerProvider({ init, children }) {
  const [bannerStore, dispatch] = useImmerReducer(bannerReducer, init || bannerInit);

  return (
    <BannerContext.Provider value={bannerStore}>
      <BannerDispatchContext.Provider value={dispatch}>
        {children}
      </BannerDispatchContext.Provider>
    </BannerContext.Provider>
  );
}

export function useBannerStore() {
  return useContext(BannerContext);
}

export function useBannerDispatch() {
  return useContext(BannerDispatchContext);
}
